import BookFreeClassBtn from '@components/common/book-free-class-btn'
import { FastlyImage } from '@components/common/image'

type Props = {
  courseName?: string
  heading?: string
  urlQuery?: string
  description?: string | JSX.Element
}

const StemAccredited = ({
  courseName,
  heading,
  urlQuery,
  description,
}: Props) => {
  return (
    <div className="flex flex-col text-grey my-10 lg:px-3 py-5 ">
      <h2 className="text-2xl font-600 mb-6 leading-tight">
        {heading && heading}
        {!heading && `${courseName} is accredited by STEM.org`}
      </h2>
      <div>
        <FastlyImage
          src="/images/curriculum/stem-accrediated.png"
          webpSrc="/images/curriculum/stem-accrediated.webp"
          width={237}
          height={107}
          alt="Stem accreditation logo"
        />
      </div>
      {description && <p className="text-lg mt-4">{description}</p>}
      {!description && (
        <p className="text-lg mt-4">
          STEM.org Educational Research is the longest continually operating
          STEM education research and credentialing organization that has served
          over 4,500 schools, districts, and organizations in over 25 countries.
          STEM.org Accreditation has been awarded to Codingal by STEM.org
          Educational Research after thoroughly examining and evaluating the
          educational institution’s curriculum, teachers, and courses for
          efficiency, effectiveness, and quality.
        </p>
      )}
      <div className="mx-auto w-full md:max-w-xs mt-12 text-center">
        <BookFreeClassBtn query={urlQuery} />
      </div>
    </div>
  )
}

export default StemAccredited
